import { paymentMethodEnum } from "./payment";
import { z } from "zod";

export const timelineEventSchema = z.object({
  id: z.string(),
  type: z.enum([
    "relation",
    "invoice-created",
    "invoice-sent",
    "estimate-created",
    "estimate-sent",
    "credit-note-created",
    "credit-note-sent",
    "expense",
    "payment",
  ]),
  date: z.date(),
  total: z.number().optional(),
  currency: z.string().optional(),
  paymentMethod: paymentMethodEnum.optional(),
});

export type TimelineEvent = z.infer<typeof timelineEventSchema>;
